import React from "react";

import UploadFile from "../../api/common/UploadFile";
import DeleteFile from "../../api/common/DeleteFile";

import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SendIcon from "@mui/icons-material/Send";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CancelIcon from "@mui/icons-material/Cancel";

import { FromInt } from "../../helpers/NumberTools";


import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const FileUploader = (props) => {
  const uploadInputRef = React.useRef();
  const [selectedFile, setSelectedFile] = React.useState(null);
  const handleUpload = async () => {
    if (!selectedFile) return;
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("dist", props.dist);
    try {
      const response = await UploadFile(props.token, formData);
      addUploadedFiles(response.data);
      setSelectedFile(null);
      // uploadInputRef.current.value = null;
    } catch (error) {
      console.log(error);
    }
  };

  const handleFileSelect = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const removeUploadedFiles = (itemId) => {
    DeleteFile(props.token, itemId);
    props.setUploadedFiles((prevUploadedFiles) => {
      return prevUploadedFiles.filter((item) => item.id !== itemId);
    });
  };

  const addUploadedFiles = (item) => {
    props.setUploadedFiles((prevUploadedFiles) => {
      return prevUploadedFiles.concat(item);
    });
  };
  return (
    <div>
      <div className="row text-right mt-1 mb-2 justify-content-center">
        <h4>افزودن پیوست</h4>

        {!selectedFile ? (
          <div className=" border-0 mt-1 col-12 ">
            {" "}
            <Button
              component="label"
              variant="contained"
              className="form-control"
              startIcon={<CloudUploadIcon />}
            >
              انتخاب فایل پیوست جدید
              <VisuallyHiddenInput
                type="file"
                ref={uploadInputRef}
                onChange={handleFileSelect}
              />
            </Button>
          </div>
        ) : (
          <div className="row m-0 p-0">
            <div className=" border-0 mt-1 col-8  justify-content-center">
              <Button
                variant="contained"
                startIcon={<SendIcon />}
                color="success"
                className="form-control"
                onClick={handleUpload}
              >
                ارسال پیوست
              </Button>
            </div>
            <div className=" border-0 mt-1 col-4 ">
              <Button
                variant="contained"
                startIcon={<CancelIcon />}
                color="error"
                onClick={() => setSelectedFile(null)}
                className="form-control"
              >
                انصراف
              </Button>
            </div>{" "}
          </div>
        )}
      </div>
     
        {props.uploadedFiles.map((uploadedFile, index) => {
          return (
            <div className="row mt-2 mb-2 border-bottom" key={index}>
              <div className="col-10 col-md-10">پیوست {FromInt(index + 1)}</div>
              <div className="col-1 ">
                <DeleteForeverIcon
                  color="error"
                  onClick={() => {
                    removeUploadedFiles(uploadedFile.id);
                  }}
                />
              </div>
            </div>
          );
        })}
      
    </div>
  );
};
export default FileUploader;
